import Settings from 'pages/Settings'
import NotificationsChannels from 'pages/settings/NotificationsChannels'
import Firewall from 'pages/settings/Firewall'
import ConfigurationManagerRoute from 'router/configurationManager'
import UserManagement from 'pages/settings/UserManagement'
import Policies from 'pages/settings/Policies'
import SecureAccess from 'pages/settings/SecureAccess'
import Notifications from 'pages/settings/Notifications'

export default [
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            requiresAuth: true,
            title: 'Settings',
        },
    },
    {
        path: '/settings/firewall',
        name: 'Firewall',
        component: Firewall,
        meta: {
            title: 'Firewall',
        },
    },
    ...ConfigurationManagerRoute,
    {
        path: '/settings/user-management',
        name: 'User Management',
        component: UserManagement,
        meta: {
            title: 'UserManagement',
        },
    },
    {
        path: '/settings/notification-channels',
        name: 'Notification channels',
        component: NotificationsChannels,
        meta: {
            title: 'NotificationsChannels',
        },
    },
    {
        path: '/settings/policies',
        name: 'Policies',
        component: Policies,
        meta: {
            title: 'Policies',
        },
    },
    {
        path: '/settings/secure-access',
        name: 'Secure Access',
        component: SecureAccess,
        meta: {
            title: 'Secure Access',
        },
    },
    {
        path: '/settings/notifications',
        name: 'Notifications',
        component: Notifications,
        meta: {
            title: 'Notifications',
        },
    }
]
